import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=b89f7ace&scoped=true&"
import script from "./Ship.vue?vue&type=script&lang=js&"
export * from "./Ship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89f7ace",
  null
  
)

export default component.exports